export const toEuro = (value) => {
    if(!value && value !== 0)return"0,00"
    return value.toLocaleString('de-DE', {
        style: "currency",
        currency: "EUR"
    })
};
export const centsToEuro = (cents) => {
    if(!cents && cents !== 0)return "0,00"
    return toEuro(cents / 100)
};
export const toDecimalNumber = (value) => {
    if(!value && value !== 0)return"0";
    return value.toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })
};
export const intToDecimalNumber = value => {
    if(!value && value !== 0)return"0,00";
    return toDecimalNumber(value / 100);
};